export default __webpack_public_path__ + "static/media/130px-Headshot.2c1a7894.webp";